import type { StyleRule } from '@archipro-design/aria';
import {
    SubheaderClassName,
    avatarClassName,
    avatarSlotClassNames,
    boxClassName,
    captionClassName,
    dialogClassName,
    dialogSlotClassNames,
    labelClassName,
    listClassName,
    listItemClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';
import { MOBILE_FULL_WIDTH } from '~/modules/design-board/config';
import { svgIconClassName } from '@archipro-design/icons';
import { headerClassName } from '@fluentui/react-northstar';

export const BottomMenuWrapper: StyleRule = ({
    theme,
    isEditPermission = false,
}) => {
    const textColor = theme.siteVariables.colors.white[100];
    const unCheckedColor = '#606060'; // not in aria
    return {
        width: pxToRem(MOBILE_FULL_WIDTH),
        background: '#262626', // not in aria
        color: textColor,

        [`& .${listClassName}`]: {
            padding: pxArrayToRem([0, 0, 56, 0]),
            [`& .${listItemClassName}`]: {
                display: 'flex',
                alignItems: 'center',
                height: pxToRem(55),
                padding: pxArrayToRem([0, 8, 0, 20]),
                [`& > .${captionClassName}`]: {
                    display: 'flex',
                    flexGrow: 1,
                    [`& > .${captionClassName}`]: {
                        flexGrow: 1,
                        fontSize: pxToRem(16),
                        color: textColor,
                        lineHeight: 1.1,
                        paddingTop: pxToRem(4),
                    },
                    [`& .${svgIconClassName}`]: {
                        width: pxToRem(18),
                        height: pxToRem(18),
                        '& svg': {
                            fill: textColor,
                        },
                    },
                    '& .comment-icon path': {
                        fill: textColor,
                    },
                    '& .share-icon': {
                        width: pxToRem(20),
                        height: pxToRem(20),
                        marginTop: pxToRem(2),
                    },
                    '& .upload-icon': {
                        width: pxToRem(16),
                        height: pxToRem(16),
                        marginTop: pxToRem(4),
                        '& svg': {
                            fill: textColor,
                            '& path': {
                                fill: textColor,
                            },
                        },
                    },
                    '& .copy-icon': {
                        '& svg': {
                            fill: textColor,
                            '& path': {
                                fill: textColor,
                            },
                        },
                    },
                    '& .arrow-icon': {
                        width: pxToRem(24),
                        height: pxToRem(24),
                        paddingTop: 0,
                        '& svg': {
                            opacity: 0.2,
                        },
                    },
                    '& .close-icon': {
                        width: pxToRem(22),
                        height: pxToRem(22),
                        marginLeft: pxToRem(-4),
                    },
                    [`& .${boxClassName}`]: {
                        '&:first-child': {
                            width: pxToRem(30),
                            margin: 0,
                        },
                        '& .check-icon': {
                            marginRight: pxToRem(12),
                            ':last-child svg': {
                                opacity: 1,
                            },
                        },
                    },
                },

                ...(isEditPermission && {
                    '&.unchecked': {
                        [`& > .${captionClassName}`]: {
                            [`& > .${captionClassName}`]: {
                                color: unCheckedColor,
                            },
                        },
                        [`& .${svgIconClassName}`]: {
                            '& svg': {
                                fill: unCheckedColor,
                            },
                        },
                        '& .comment-icon path': {
                            fill: unCheckedColor,
                        },
                    },

                    '&.remove': {
                        marginTop: pxToRem(28),
                    },
                }),
            },
        },
    };
};

export const RemoveRow: StyleRule = () => ({
    marginTop: pxToRem(28.5),
});

export const DeleteDialog: StyleRule = () => ({
    [`&.${dialogClassName}`]: {
        borderRadius: 0,
        width: pxToRem(370),
        minHeight: pxToRem(225),
        padding: 0,
        [`& .${dialogSlotClassNames.content}`]: {
            padding: 0,
        },
    },
});

export const MenuAvatar: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 18, 20, 10]),
    marginBottom: pxToRem(-4),
    gap: pxToRem(8),
    borderBottom: `1px solid ${theme.siteVariables.colors.charcoal[100]}`,
    [`& .${avatarClassName}`]: {
        width: pxToRem(52),
        height: pxToRem(52),
        border: 0,
        [`& > .${labelClassName}`]: {
            color: theme.siteVariables.colors.white['FFF'],
        },
        [`& .${avatarSlotClassNames.image}`]: {
            backgroundColor: 'transparent',
        },
    },
    [`& .${headerClassName}`]: {
        margin: pxArrayToRem([7, 0, 7, 0]),
        fontSize: pxToRem(20),
        color: theme.siteVariables.colors.white['FFF'],
        letterSpacing: 0,
    },
    [`& .${SubheaderClassName}`]: {
        fontSize: pxToRem(14),
        color: '#828282', // not in aria
        letterSpacing: 0,
    },
});
